import React from "react"
import PropTypes from "prop-types"
import {mapKeys, upperFirst} from "lodash"
import {Query as PerkboxQuery} from "@irati/utils/services/apollo"

import Error from "../renderers/Error"


const Query = ({children, useError, withHistoricalData, historicalProps, ...props}) => {
  return (
    <PerkboxQuery {...props} useError={false}>
      {(apollo) => {
        if (apollo.error && useError) return <Error apollo={apollo} />
        return (
          <PerkboxQuery {...historicalProps} query={props.query} useError={false} useLoader={false} skip={!withHistoricalData}>
            {(historicalApollo) => {
              return children({...apollo, ...mapKeys(historicalApollo, (_, key) => `historical${upperFirst(key)}`)})
            }}
          </PerkboxQuery>
        )
      }}
    </PerkboxQuery>
  )
}

Query.propTypes = {
  children: PropTypes.func.isRequired,
  useError: PropTypes.bool,
  withHistoricalData: PropTypes.bool,
  historicalProps: PropTypes.object
}

Query.defaultProps = {
  useError: true,
  withHistoricalData: false,
  historicalProps: {}
}

export default Query
